export const Language = {
  English: "en",
  French: "fr",
  Portuguese: "pt",
};

export const DEFAULT_LANGUAGE = Language.English;
export const SUPPORTED_LANGUAGES = Object.values(Language);
